import {Payload} from '../../../payload/payload';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {HttpClient} from '@angular/common/http';
import {BaseActionService} from './baseAction.service';

export abstract class AbstractActionService<P extends Payload, Result> extends BaseActionService<P, Result>{

    readonly entityName: string;
    readonly actionName: string;
    readonly customizeHttpUrlGenerator: CustomizeHttpUrlGenerator;

    protected constructor(entityName: string,
                          actionName: string,
                          customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                          httpClient: HttpClient) {
        super(customizeHttpUrlGenerator.getEntityCollectionResourceUrl(entityName) + 'action-' + actionName, httpClient);
        this.entityName = entityName;
        this.actionName = actionName;
        this.customizeHttpUrlGenerator = customizeHttpUrlGenerator;
    }

    protected onResponse(response: Result, payload: P) {
    }
}
